import formatTableJson from '@/config/tableComponentParams.js'
import { taskStatus } from '@/config/status'
import i18n from '@/locales'
export default formatTableJson([
  {
    filed: 'name',
    label: i18n.t('Fota.taskName')
  },
  {
    filed: 'status',
    label: i18n.t('Fota.taskStatus'),
    type: 'status',
    statusProps: taskStatus,
    formatFn: function(_, row) {
      switch (row.status) {
        case 'EXAMINE_WAIT':
          return i18n.t('Fota.EXAMINE_WAIT')
        case 'EXAMINE_REJECT':
          return i18n.t('Fota.EXAMINE_REJECT')
        case 'ENABLE':
          return i18n.t('Fota.ENABLE')
        case 'DISABLE':
          return i18n.t('Fota.DISABLE')
        default:
          return '-'
      }
    }
  },
  {
    filed: 'targetType',
    label: i18n.t('Fota.targetType'),
    formatFn: function(_, row) {
      switch (row.targetType) {
        case 'VERSION':
          return i18n.t('Fota.targetVERSION')
        case 'DEVICE':
          return i18n.t('Fota.targetDEVICE')
        default:
          return '-'
      }
    }
  },
  // {
  //   filed: 'upgradeType',
  //   label: '升级方式',
  //   formatFn: function(_, row) {
  //     switch (row.targetType) {
  //       case 'FORCE':
  //         return '强制升级'
  //       case 'NOT_FORCE':
  //         return '自主升级'
  //       default:
  //         return '-'
  //     }
  //   }
  // },
  {
    filed: 'srcVersion',
    label: i18n.t('Fota.destVersion')
  },
  {
    filed: 'destVersion',
    label: i18n.t('Fota.srcVersion')
  },
  {
    filed: 'successDeviceCount',
    label: i18n.t('Fota.successDeviceCount'),
    formatFn: function(_, row) {
      if (row.successDeviceCount > 0 && row.deviceCount > 0) {
        return row.successDeviceCount + '/' + row.deviceCount
      } else {
        return '-'
      }
    }
  },
  {
    filed: 'examineAdminName',
    label: i18n.t('Fota.examineAdminName')
  },
  {
    filed: 'startTime',
    label: i18n.t('Fota.updateStartTime'),
    type: 'time',
    timeFormat: 'YYYY-MM-DD HH:mm',
    width: 170
  }
])
